import { render, staticRenderFns, recyclableRender, components } from "./search.vue?vue&type=template&id=039252a3&scoped=true&"
var renderjs
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=039252a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../hbuilderX/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039252a3",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/search.vue"
export default component.exports